import script from "./ipwhiteplatformInstitutions.vue?vue&type=script&setup=true&lang=js"
export * from "./ipwhiteplatformInstitutions.vue?vue&type=script&setup=true&lang=js"

import "./ipwhiteplatformInstitutions.vue?vue&type=style&index=0&id=0b558eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b558eb9"]])

export default __exports__